interface RoleChoice {
    name?: string;
    description?: string;
    retired?: boolean;
}

export const roleOptionText = (record?: RoleChoice): string => {
    if (!record?.name) {
        return '';
    }

    const label = record.description ? `${record.name} — ${record.description}` : record.name;

    return record.retired ? `${label} (abgelöst, nicht mehr vergebbar)` : label;
};
